import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { HXMobilePageTitleText } from "./HXMobilePage.styles";
export const PreLoginParent = styled(FlexColumnDiv) `
    height: 100%;
    align-items: center;
    flex: 1 0 0;
`;
export const PreLoginContent = styled(FlexColumnDiv) `
    margin-top: 56px;
    align-items: center;
    gap: 40px;
    flex: 1 0 0;
    width: 45%;
`;
export const PreLoginBody = styled(FlexColumnDiv) `
    align-items: center;
    width: 70%;
    height: 100%;
    justify-content: flex-start;
`;
export const PreLoginTitleAndDescription = styled(FlexColumnDiv) `
    align-items: center;
    justify-content: center;
    gap: 24px;
    text-align: center;
    font-size: ${fontSizes.MASSIVE};
    color: ${colors.navy_dark};
`;
export const PreLoginTitle = styled(HXMobilePageTitleText) ``;
export const PreLoginDescription = styled.div `
    letter-spacing: 0.15px;
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_light};
`;
export const PreLoginFooter = styled(FlexColumnDiv) `
    margin-bottom: 92px;
    margin-top: 24px;
`;
